"use strict";

// Class definition
var KTAccountSettingsOverview = function () {
    // Private functions
    var initSettings = function() {

    }

    // Public methods
    return {
        init: function () {
            initSettings();
        }
    }
}();

// On document ready
KTUtil.onDOMContentLoaded(function() {
    KTAccountSettingsOverview.init();
});
